import { NavigationGuardNext, Route } from "vue-router";

export const IntelliticksGuard = (
  to: Route,
  from: Route,
  next: NavigationGuardNext
) => {
  /*
  TODO por implementar seguridad en rutas para los componentes publicos usados por intelliticks
  */
  next();
};
